import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Printer from './printer.js'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/events',
      name: 'event',
      component: () => import(/* webpackChunkName: "eventpage" */ './views/Events.vue' )
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import(/* webpackChunkName: "eventpage" */ './views/Calendar.vue' )
    },
    {
      path: '/volunteer',
      name: 'volunteer',
      component: () => import(/* webpackChunkName: "eventpage" */ './views/Volunteer.vue' )
    },
    {
      path:'/eventbyid',
      name:'eventbyid',
      component: () => import(/* webpackChunkName: "eventpage" */ '@/components/event/EventById')
    },
    {
      path: '/auth/signin',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Signin'),
    },
    {
      path: '/auth/signup',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Signup')
    },
    {
      path: '/auth/confirm',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/Confirm')
    },
    {
      path: '/auth/forgotpassword',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/ForgotPassword'),
    },
    {
      path: '/auth/entercode',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/EnterCodeReset')
    },
    {
      path: '/auth/resetpassword',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/ResetPassword')
    },
    {
      path: '/auth/inviteconfirm',
      component: () => import(/* webpackChunkName: "auth" */'@/views/auth/InviteConfirm')
    },
    {
      path: '/authenticated',
      component: () => import (/* webpackChunkName: "authenticated"*/ '@/views/Authenticated')
    },
    {
      path: '/paymentmethods',
      component: () => import (/* webpackChunkName: "authenticated"*/ '@/views/customers/Payment')
    }
  ]
})
router.printdata = JSON.parse(window.localStorage.getItem('print'))

router.afterEach((to, from) => {
  // console.log('DDWT',router.printdata)
  if(!router.printdata || router.printdata === null){
    Printer.print('scottsdalebeachfest')
    setTimeout(function(){
      router.printdata = JSON.parse(window.localStorage.getItem('print'))
      // console.log('RoutePrintA:',router.printdata)
    },2000)
  } else {
    router.printdata.path = to.path
    // console.log('RoutePrintB:',router.printdata)
    Printer.sendData(router.printdata)
  }
  // setTimeout(function(){
  //   let p = window.localStorage.getItem('print')
  //   if(p){
  //     this.printdata = JSON.parse(p)
  //   }
  // },2000)
})


if (process.env.VUE_APP_GOOGLE_ANALYTICS) {
  Vue.use(require('vue-analytics').default, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}

export default router